import { Input } from '@chakra-ui/react'
import type { IssueSchema } from '@gitbeaker/core'
import { useQuery } from '@tanstack/react-query'
import { useState } from 'react'
import { useHttpClient } from 'src/adapters/HTTPClient'
import { Issue } from 'src/Issue'

import './styles.css'
import { useGitlabClient } from '../../adapters/GitlabClient'
import { useIdentity } from '../../adapters/Identity'

type Props = {
  projectId?: number
}

export function IssuesPicker(props: Props) {
  const { projectId } = props
  const [query, setQuery] = useState<string>()

  return (
    <>
      <label className="search-input-wrapper">
        Ticket
        <Input
          placeholder={projectId ? 'tous' : 'qui me sont assignés'}
          type="text"
          onInput={(event) => setQuery((event.target as any).value)}
        />
      </label>
      <IssuesList project={projectId} query={query} />
    </>
  )
}

type IssuesListProps = {
  project?: number
  query?: string
}

// https://docs.gitlab.com/ee/api/issues.html
function IssuesList(props: IssuesListProps) {
  const { project, query } = props
  const httpClient = useHttpClient()
  const gitlabClient = useGitlabClient()

  const searchEnabled = (query || '').length > 2
  const scope = searchEnabled || project ? 'all' : 'assigned_to_me'

  const [user] = useIdentity()

  const { isLoading, isError, data } = useQuery<IssueSchema[]>({
    queryKey: [
      '/issues',
      project,
      searchEnabled,
      query,
      gitlabClient.Issues,
      user?.id,
      httpClient,
      scope,
    ],
    enabled: Boolean(user?.id),
    queryFn: async () => {
      const issues = await gitlabClient.Issues.all({
        state: 'opened',

        scope: 'all',
        projectId: project,
        groupId: undefined,
        search: searchEnabled ? query : undefined,
        perPage: 200,
        assigneeId: searchEnabled ? undefined : user?.id,
      })

      return issues
    },
  })

  if (isLoading) {
    return <ul className="issues-list">Chargement…</ul>
  }

  if (isError) {
    return <ul className="issues-list">Une erreur est survenue</ul>
  }

  return (
    <ul className="issues-list">
      {!data?.length && 'Aucun résultat'}
      {data?.map((issue) => (
        <Issue
          key={issue.id}
          issue={issue}
          compact
          draggable
          onDragStart={(event) => {
            const partialIssue = {
              id: issue.id,
              iid: issue.iid,
              project_id: issue.project_id,
            }
            event.nativeEvent.dataTransfer?.setData(
              'application/json',
              JSON.stringify(partialIssue),
            )
          }}
        />
      ))}
    </ul>
  )
}
